import React from "react";

const BottomImageContainer = () => {
  return (
    <>
      <div>
        <img
          // className="imageContainer"
          height={42}
          style={{
            display: "flex",
            margin: "11px 0px 2px 0px",
            maxWidth: "100%",
          }}
          src="https://lh3.googleusercontent.com/d/1ZVlqQbrNODuYO_91C2fqSFkg_mT27HT2"
          alt="LogoFull"
        />
      </div>
      <div>
        <img
          // className="imageContainer"
          height={72}
          style={{
            display: "flex",
            margin: "5px 0px 2px 0px",
            maxWidth: "100%",
          }}
          src="https://lh3.googleusercontent.com/pw/AP1GczMxY0S_c1JyYPKuhn0Z9oMjw5NHUnD8DzrpX0bp18gBnUVMBvW930fsMjGPDLrRVTUEQk57YdDmuMwnQeQF-VTs3pj_-kYTd5d7xND0YaJNEohl6cEY9htQMRxKNTNpnnebxqC_iZ3MxQQe1oI9H75-=w957-h320-s-no-gm?authuser=0"
          alt="LogoFull"
        />
      </div>

      <table>
        <tbody>
          <tr>
            <td>
              <a
                href="https://twitter.com/bim_ventures"
                style={{
                  textDecorationLine: "none",
                  color: "rgb(1,0,57)",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                <img
                  style={{
                    margin: "5px 0 5px 0",
                  }}
                  height={14}
                  src="https://lh3.googleusercontent.com/pw/AP1GczMBZxC8WfRn3B83L_NgmtJCa2OmSYCFXT7NCC1pvvzdOUQuoExVm7DXyvS7q4VqaO8WLASovSmvaQFPyjsR0BjlnYEs2fdJ6o9o5uJRaVtLgZPJwcChO9yAxCeNGzSQ9khqSqnalbXl1OPWRubK-Bo=w512-h512"
                  alt="twitter"
                />
              </a>
            </td>
            <td>
              <a
                href="https://www.instagram.com/bim_ventures?igsh=NGxjd242cjBia2Ri"
                style={{
                  textDecorationLine: "none",
                  color: "rgb(1,0,57)",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                <img
                  height={16}
                  style={{
                    margin: "5px 0 5px 0",
                  }}
                  src="https://lh3.googleusercontent.com/pw/AP1GczMtbLq-n0NgwvgIZHrpSU5nVSPTITZ9iZmTF02DCfqVCrpVmzKmGAUoUiGRX1HCzcQB7PKPyCceQYMYN4iveiqjA8gEoYlSvmZty_JszexPOOXWkAhHx_O_8iC7MgpdNgJH7La4QFpn5I_-Qn1HVBFY=w512-h512"
                  alt="Instagram"
                />
              </a>
            </td>
            <td>
              <a
                href="https://www.linkedin.com/company/bimventures"
                style={{
                  textDecorationLine: "none",
                  color: "rgb(1,0,57)",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                <img
                  height={16}
                  style={{
                    margin: "5px 0 5px 0",
                  }}
                  src="https://lh3.googleusercontent.com/d/14T69JJY5qFPRMk-Sa62_dClgzQYqVXrE"
                  alt="linkedIn"
                />
              </a>
            </td>
          </tr>
        </tbody>

      </table>
      <div>
        <p
          style={{
            textDecorationLine: "none",
            fontSize: "12px",
            color: "#000000",
            fontWeight: "700",
            margin: "0px 6px 6px 0px",
            marginTop: "18px",
          }}
        >
          Disclaimer
        </p>
        <p
          style={{
            textDecorationLine: "none",
            fontSize: "12px",
            color: "rgb(166, 170, 173)",
            marginTop: "4px",
          }}
        >
      The information transmitted in this email is intended only for the person or entity to whom it is addressed and may contain proprietary, business-confidential, and/or legally privileged information. If you are not the intended recipient of this message, you are hereby notified that any use, review, retransmission, dissemination, distribution, reproduction, or any action taken in reliance upon this message is strictly prohibited. If you have received this email in error, please notify the sender immediately and delete this email and its contents from your system.Any views or opinions expressed in this message are those of the individual sender and do not necessarily reflect the views of BIM Ventures or its affiliates.
        </p>
      </div>
    </>
  );
};

export default BottomImageContainer;
